import { createAction } from 'redux-actions';

import { RESET_STATE } from '../constants';

export default createAction(RESET_STATE);
